import { render, staticRenderFns } from "./Textarea2.vue?vue&type=template&id=24446a1a&scoped=true"
import script from "./Textarea2.vue?vue&type=script&lang=js"
export * from "./Textarea2.vue?vue&type=script&lang=js"
import style0 from "./Textarea2.vue?vue&type=style&index=0&id=24446a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24446a1a",
  null
  
)

export default component.exports